/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/arrow_down_medium'
export default icon
